import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/api";
import authReducer from "./slices/auth";
import formReducer from "./slices/form";
import gradingFormReducer from "./slices/gradingForm";

const reducer = {
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  form: formReducer,
  gradingForm: gradingFormReducer,
};

const store = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});

export default store;
